// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1JXa7","header":"Messages_header__2FcbM"};